<template>
  <v-flex>
    <v-select
      v-if="index > 0"
      v-model="operation"
      :items="operationOptions"
      @input="updateSelf" />

    <v-checkbox
      v-model="isNot"
      label="NOT"
      @change="updateSelf" />

    <v-btn
      @click.stop="deleteSelf"
    >
      Delete group
    </v-btn>

    <v-btn
      @click.stop="addTerm('Rule')"
    >
      Add new term
    </v-btn>

    <v-btn
      @click.stop="addTerm('SavedQueryGroup')"
    >
      Add new group
    </v-btn>

    <component
      v-for="(term, termIndex) in terms"
      :key="term.id"
      :is="term.type"
      :index="termIndex"
      :depth="term.type === 'SavedQueryGroup'
      ? depth + 1 : depth"
      :field-options="fieldOptions"
      @add-term="addTerm"
      @delete-term="deleteTerm"
      @update-term="updateTerm" />
  </v-flex>
</template>

<script>
import SavedQueryRule from '@/components/SavedQueryRule'

export default {
  name: 'SavedQueryGroup',

  components: {
    'Rule': SavedQueryRule
  },

  props: {
    index: {
      type: Number,
      default: 0
    },

    depth: {
      type: Number,
      default: 0
    },

    fieldOptions: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      operationOptions: [
        'OR',
        'AND'
      ],
      operation: '',
      isNot: false,
      terms: []
    }
  },

  computed: {
    query: {
      get () {
        const operation = this.index > 0
          ? `${this.operation} `
          : ''
        const isNot = this.isNot
          ? 'NOT '
          : ''
        const queries = this.terms.map(term => {
          return term.query
        })
        return `${operation}${isNot}(${queries.join(' ')})`
      }
    }
  },

  methods: {
    addTerm (type) {
      this.terms.push({
        type,
        query: ''
      })
    },

    deleteTerm (index) {
      this.terms.splice(index, 1)
    },

    updateTerm (index, query) {
      this.terms[index].query = query
      this.updateSelf()
    },

    deleteSelf () {
      this.$emit('delete-term', this.index)
    },

    updateSelf () {
      this.$emit('update-term', this.index, this.query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SavedQueryGroup.vue